import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Footer } from "../../Common/Footer/Footer";
import "./verifyMail.css";
import { base_url } from "../BackendAPIUrl";
import ClipLoader from "react-spinners/ClipLoader";

const VerifyEmail = ({ lang }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(null); // null = loading, true = verified, false = error
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const direction = lang === "ar" ? "rtl" : "ltr";
    if (document.body.dir !== direction) {
      document.body.dir = direction;
    }
  }, [lang]);

  useEffect(() => {
    const verifyEmail = async () => {
      if (!id) {
        setVerified(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${base_url}/api/verify-email/${id}/`
        );
        if (response.status === 200 || response.status === 201) {
          setVerified(true);
          setLoading(false);
        } else {
          setVerified(false);
          setLoading(false);
        }
      } catch (error) {
        console.error("Email verification error:", error);
        setVerified(false);
        setLoading(false);
      }
    };

    verifyEmail();
  }, [id]);

  useEffect(() => {
    if (verified === true) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate("/login");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [verified, navigate]);

  return (
    <div className={`verify-wrapper relative`}>
      <div className="error-popup !bg-yellow-50">
        {loading ? (
          <div className="flex flex-col items-center justify-center gap-4">
            <ClipLoader size={30} color={"#842029"} />
            <p>
              {lang === "ar"
                ? "جارٍ التحقق من البريد الإلكتروني..."
                : "Verifying email..."}
            </p>
          </div>
        ) : verified === true ? (
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-green-600 font-semibold">
              {lang === "ar"
                ? "تم التحقق من البريد الإلكتروني بنجاح"
                : "Email verified successfully"}
            </p>
            <p className="text-sm text-gray-600">
              {lang === "ar"
                ? `سيتم إعادة التوجيه إلى صفحة تسجيل الدخول خلال ${countdown} ثانية...`
                : `Redirecting to login page in ${countdown} seconds...`}
            </p>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center gap-2">
            <p className="text-red-600 font-semibold">
              {lang === "ar"
                ? "فشل التحقق من البريد الإلكتروني"
                : "Email verification failed"}
            </p>
            <p className="text-sm text-gray-600">
              {lang === "ar"
                ? "يرجى المحاولة مرة أخرى أو استخدام رابط التحقق الجديد"
                : "Please try again or use a new verification link"}
            </p>
          </div>
        )}
      </div>

      <div className="absolute bottom-0 w-full">
        <Footer isLang={lang} />
      </div>
    </div>
  );
};

export default VerifyEmail;

